class SettlementStartType {
    constructor(serverType) {
        this.serverType = serverType;
    }

    translate(t) {
        return t(`auctions.settlement-start-type.${this.serverType.toLowerCase().replace(/_/g, '-')}`);
    }
}

export const T_1 = new SettlementStartType('T_1');
export const T_2 = new SettlementStartType('T_2');
export const T_3 = new SettlementStartType('T_3');
export const T_4 = new SettlementStartType('T_4');
export const T_5 = new SettlementStartType('T_5');

export const getSettlementStartType = (serverType) => {
    let result = null;
    switch (serverType) {
        case 'T_1':
            result = T_1;
            break;
        case 'T_2':
            result = T_2;
            break;
        case 'T_3':
            result = T_3;
            break;
        case 'T_4':
            result = T_4;
            break;
        case 'T_5':
            result = T_5;
            break;
        default:
            throw new Error(`Unknown settlement start type: ${serverType}`);
    }
    return result;
};

export const getAllSettlementStartTypes = () => [
    T_1,
    T_2,
    T_3,
    T_4,
    T_5,
];
